import "./cover.css";
import { ShareButton } from "./ShareButton";

export function CoverPage(): React.JSX.Element {
  return (
    <main className="cover-page">
      <h1 className="visually-hidden">七维排课助手</h1>
      <figure className="software-cover">
        <img
          className="software-cover-image"
          src="/brand/qivid-scheduler-cover.webp"
          width="2048"
          height="1152"
          alt="七维排课助手软件封面"
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
        <a className="solid-button cover-start-button" href="/projects">
          开始使用
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </a>
        <ShareButton />
        <a
          className="cover-footer-link"
          href="https://qiwiedu.com/"
          target="_blank"
          rel="noreferrer"
        >
          七维教育，支持每一位特殊儿童的全生涯发展。
        </a>
      </figure>
    </main>
  );
}
